import React from "react";
import "./transactions.css";

const Transactions = () => {
  return (
    <>
      <div className="transactions">
        <h3>Transactions</h3>
        <p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-trending-up avatar-icon font-medium-3"
          >
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
            <polyline points="17 6 23 6 23 12"></polyline>
          </svg>
          <span className="text-titles tfortexts">Last Deposit</span>{" "}
          <span className="colors">$ n/a</span>
        </p>
        <p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-trending-down font-medium-3"
          >
            <polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline>
            <polyline points="17 18 23 18 23 12"></polyline>
          </svg>
          <span className="text-titles tfortexts">Last Withdrawal</span>{" "}
          <span className="colors-red">$ n/a</span>
        </p>
        <p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-activity avatar-icon font-medium-3"
          >
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
          </svg>
          <span className="text-titles tfortexts">Balance </span>
          {/* <span className="small">Totals</span> */}
          <span className="colors">$ 0.00</span>
        </p>{" "}
        <p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-credit-card avatar-icon font-medium-3"
          >
            <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
            <line x1="1" y1="10" x2="23" y2="10"></line>
          </svg>
          <span className="text-titles tfortexts">Active </span>
          {/* <span className="small">Deposit</span> */}
          <span className="colors-orange">$ 0.00</span>
        </p>
        <p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-refresh-ccw avatar-icon font-medium-3"
          >
            <polyline points="1 4 1 10 7 10"></polyline>
            <polyline points="23 20 23 14 17 14"></polyline>
            <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
          </svg>
          <span className="text-titles tfortexts">Withdraw </span>
          {/* <span className="small">Payments</span> */}
          <span className="colors-orange">$ 0.00</span>
        </p>
        <p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-bar-chart-2 avatar-icon font-medium-3"
          >
            <line x1="18" y1="20" x2="18" y2="10"></line>
            <line x1="12" y1="20" x2="12" y2="4"></line>
            <line x1="6" y1="20" x2="6" y2="14"></line>
          </svg>
          <span className="text-titles tfortexts">Deposit </span>
          {/* <small>funds</small> */}
          <span className="colors-orange">$ 0.00</span>
        </p>
      </div>
    </>
  );
};

export default Transactions;
